"use strict";

/**
 * Plain old identity function
 */

module.exports = function (x) {
  return x;
};